const apiurl = 'https://tea.steelobpo.com/api/'

export const appSettings = {
  apiurl: apiurl,
  authurl: apiurl + '/oauth/token',
  logouturl: apiurl + '/logout',
  defaultLoginRequest: {
    client_id: '82',
    client_secret: 'KivrDU3zkU0QNkmw612xbn3gdzaEjvQCVY265tE3',
    grant_type: 'password',
    scope: '*',
    username: '',
    password: ''
  },
  logos: {
    loginTop: 'static/Logo_dytnet.png',
    loginLogo: 'CustomModules/GlobalBPOCore/assets/logo_cgm.png',
    menuLogo: 'static/Logo_dytnet.png',
    globalLoginLogo: 'logo_cgm.png'
  },
  title: 'STEELO APP',
  recaptcha: {
    enabled: true,
    site_key: '6LfeHYMdAAAAAIU0mSW5xvjd9rpOYcqDRjuGlfMK',
    loaderOptions: {
      explicitRenderParameters: {
        badge: 'bottomleft'
      }
    }
  },
 login: {
    video: 'video steel.mp4',
    logo: 'logo_tea.png',
    message: 'Steel`O App',
    loginFirstColor: '#0a4ab6', /* #93d22f */
    loginTextColor: '#FFFFFF',
    loginTransparency: 0.5
  },
  customDashboardBg: '#28353a !important',
  baseWebTitle: 'Tea'
}




// WEBPACK FOOTER //
// ./src/store/app_settings.js